module.exports = "/static/Images/en/survey_yes.png";